import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModuleItem, ModuleItemBase } from '../layout/sidebar/types';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ExternalModuleList, TenantModules } from '../layout/sidebar/module-list';

@Injectable({
    providedIn: 'root',
})
export class SidebarStateService {
    private router = inject(Router);
    private sidebarExpandedSubject = new BehaviorSubject<boolean>(false);
    private moduleDataSubject = new BehaviorSubject<ModuleItem | null>(null);

    public isExpanded$: Observable<boolean> = this.sidebarExpandedSubject.asObservable();
    public moduleData$: Observable<ModuleItem | null> = this.moduleDataSubject.asObservable();

    constructor() {
        this.initializeModuleDataSubscription();
    }
    get isExpanded() {
        return this.sidebarExpandedSubject.getValue();
    }

    toggleSidebarState(): void {
        this.sidebarExpandedSubject.next(!this.isExpanded);
    }

    setSidebarState(isExpanded: boolean): void {
        this.sidebarExpandedSubject.next(isExpanded);
    }

    private initializeModuleDataSubscription(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            const fullPath = this.router.url.split('?')[0];
            const currentPath = fullPath.split('/')[1];

            const lookupId = currentPath === 'ontology' ? 'datahub' : currentPath;

            let foundModule: ModuleItemBase | null = TenantModules.find(m => m.id === lookupId) || null;

            if (!foundModule) {
                for (const moduleList of ExternalModuleList) {
                    const moduleItem = moduleList.modules?.find(m => m.id === lookupId);
                    if (moduleItem) {
                        foundModule = moduleItem;
                        break;
                    }
                }
            }

            this.moduleDataSubject.next(foundModule);
        });
    }
}
